export const DEFAULT_LOCAL = 'en_US';

export function parseLabel(
    labels: { [locale: string]: string } | string,
    userLocale: string
  ): string {
    if (typeof labels === 'string') {
      return labels;
    }
  
    if (!labels || Object.keys(labels).length === 0) {
      return '';
    }
  
    const label =
      labels[userLocale] ??
      labels[DEFAULT_LOCAL] ??
      labels[Object.keys(labels)[0]];
  
    return label?.replace(/\\/g, '') ?? '';
  }